import { inject, Injectable } from '@angular/core';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';

/**
 * The Fuse template ships ~20 mock APIs of demo data (mailbox, e-commerce, crypto, academy…),
 * all of which were registered here and instantiated at startup even though this app renders
 * none of them.
 *
 * Only the navigation one is load-bearing: it isn't demo data any more, it builds the side menu
 * and filters it by the user's roles. Everything else now goes to the real backend.
 */
@Injectable({ providedIn: 'root' })
export class MockApiService {
    navigationMockApi = inject(NavigationMockApi);
}
